export default {
  state: {
    adminUser: {
      selectedRoles: [],
      selectedTeams: [],
      selectedPermissions: [],
      password: '',
      password_confirmation: '',
    },
    adminUserActivities: [],
  },
  mutations: {
    SET_ADMIN_USER(state, payload) {
      state.adminUser = payload.user;
      state.adminUser.selectedRoles = Object.keys(state.adminUser.roles).map(i => state.adminUser.roles[i].id);
      state.adminUser.selectedTeams = Object.keys(state.adminUser.teams).map(i => state.adminUser.teams[i].id);
      if (state.adminUser.permissions) {
        state.adminUser.selectedPermissions = Object.keys(state.adminUser.permissions).map(i => state.adminUser.permissions[i].id);
      }
    },
    SET_ADMIN_USER_ACTIVITIES(state, payload) {
      state.adminUserActivities = payload.activities;
    },
    UPDATE_ADMIN_USER(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    DELETE_ADMIN_USER(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    RESTORE_ADMIN_USER(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
  },
  actions: {
    async GET_ADMIN_USER({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/users/${payload}/edit`);
        commit('SET_ADMIN_USER', data);
      } catch (err) {
        throw err;
      }
    },
    async UPDATE_ADMIN_USER({ commit }, payload) {
      try {
        const { id } = payload;
        const { data } = await window.axios.put(`/admin/users/${id}`, payload);
        commit('UPDATE_ADMIN_USER', data);
      } catch (err) {
        throw err;
      }
    },
    async UPDATE_ADMIN_USER_PERMISSION({ commit }, payload) {
      try {
        const { id } = payload;
        const { data } = await window.axios.put(`/admin/users/${id}/update/permissions`, payload);
        commit('UPDATE_ADMIN_USER', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_USER_ACTIVITIES({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/users/${payload}/activities`);
        commit('SET_ADMIN_USER_ACTIVITIES', data);
      } catch (err) {
        throw err;
      }
    },
    async DELETE_ADMIN_USER({ commit }, payload) {
      try {
        const { data } = await window.axios.delete(`/admin/users/${payload}`);
        commit('DELETE_ADMIN_USER', data);
      } catch (err) {
        throw err;
      }
    },
    async RESTORE_ADMIN_USER({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/users/${payload}/restore`);
        commit('RESTORE_ADMIN_USER', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    adminUser(state) {
      return state.adminUser;
    },
    adminUserActivities(state) {
      return state.adminUserActivities;
    },
  },
};
